import type { RouteRecordRaw } from 'vue-router/auto'


// 👉 Redirects
export const redirects: RouteRecordRaw[] = [
  // ℹ️ We are redirecting to different pages based on role.
  // NOTE: Role is just for UI purposes. ACL is based on abilities.
  // {
  //   path: '/',
  //   name: 'index',
  //   redirect: to => {
  //     // TODO: Get type from backend
  //     const userData = useCookie<Record<string, unknown> | null | undefined>('userData')
  //     const userToken = useCookie<Record<string, unknown> | null | undefined>('userToken')

  //     console.log('userToken: ', userToken)

  //     if (userToken && userToken.value && userToken.value != '') {
  //       return { name: 'root' }
  //     }

  //     // return { name: 'login', query: to.query }
  //   },
  // },
]

export const routes: RouteRecordRaw[] = [

]
